import ReferencesEntry from './references-entry';

export default class ReferencesEntryDesktop extends ReferencesEntry {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/references/entry/references-entry.desktop.js